export default __webpack_public_path__ + "static/media/transparent.3e2aec27.svg";